export enum FormSections {
    PreScreening = 1,
    MedicalIssues = 2,
    FamilyHistory = 3,
    WhoAreYou = 4,
    IntroduceYourself = 5,
    All = 6,
}
